<template>
  <div class="footer">
      <b-nav small align="center">
        <b-nav-item>
          <b-link class="footerlink" href="#" @click="toPrivacy">Privacy</b-link>
        </b-nav-item>
        <b-nav-item>
          <b-link class="footerlink" href="#" @click="toTerms">Terms</b-link>
        </b-nav-item>
        <b-nav-item href="https://ike-dai.github.io/logcrow-doc/" target="_blank">
          <b-link class="footerlink" href="https://ike-dai.github.io/logcrow-doc/" target="_blank">Docs</b-link>
        </b-nav-item>
        <b-nav-item disabled>
          <div class="footertext">Copyright © Daisuke Ikeda. All Rights Reserved.</div>
        </b-nav-item>
      </b-nav>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {},
  data () {
    return {
    }
  },
  methods: {
    toPrivacy: function () {
      this.$router.push('/privacy')
    },
    toTerms: function () {
      this.$router.push('/terms')
    },
  }
}
</script>

<style>
.footerlink {
  color: #ffffff
}
.footerlink:hover {
  color: #ffffff
}
.footertext {
  color: #ffffff
}
.footer {
  background-color: #343a40;
}
</style>
